/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Company_TaxInputs */

const vi_invoice_company_tax = /** @type {(inputs: Invoice_Company_TaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã số thuế`)
};

/**

* @param {Invoice_Company_TaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_company_tax = /** @type {((inputs?: Invoice_Company_TaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Company_TaxInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_company_tax(inputs)
});